(ns frontend.view.nev.kyc.process-status-views.submitted-status
  (:require
   [common.localization :as loc]
   [frontend.actions.kyc-process :as kyc-process-actions]
   [ui.editors.labelled-input.view :as labelled-input]
   [frontend.logging :as logging]
   [frontend.state.current-session :as session]
   [frontend.view.entity-viewers.modules.attachments :as attachments]
   [frontend.view.modals.dynamic.view :as dynamic-modal]
   [frontend.view.modals.events :as modals]
   [frontend.view.nev.kyc.process-status-views.edit-view :as edit-view]
   [frontend.view.nev.kyc.process-status-views.view-utils :as kvu]
   [frontend.zap-time :as zap-time]
   [ui.components.button.view :as button]
   [frontend.view.nev.kyc.process.screening-profile-table :refer [get-containing-kyc-profile]]
   [common.entity :as entity]
   [common.util :as cu]))

(defn on-approve-clicked
  [process-entity kyc-profile]
  (let [process-id (:db/id process-entity)
        tenant-kyc-profile? (-> kyc-profile
                                :entity/type
                                (= :entity.type/tenant-kyc-profile))
        contract-kyc-profile? (-> kyc-profile
                                  :entity/type
                                  (= :entity.type/contract-kyc-profile))
        skip-risk-category? (or tenant-kyc-profile? contract-kyc-profile?)]
    (modals/open-modal!
     dynamic-modal/modal-key
     {:title               (loc/tr :approve)
      :on-show             (fn [modal-state]
                             (let [approval-date (or (:kyc-process/approval-date process-entity)
                                                     (zap-time/now))
                                   risk-category-id (:kyc-profile/risk-category kyc-profile)
                                   risk-category (when risk-category-id
                                                   {:value risk-category-id
                                                    :label (-> risk-category-id
                                                               session/get-entity
                                                               entity/display-string)})]
                               (if skip-risk-category?
                                 (swap! modal-state assoc
                                        :kyc-profile/approval-date approval-date)
                                 (swap! modal-state assoc
                                        :kyc-profile/approval-date approval-date
                                        :kyc-profile/risk-category risk-category
                                        :justification-for-risk-category ""))))
      :render-fn           (fn [modal-state]
                             [:div
                              [:p.mb-3 (loc/tr :kyc-approve-set-approval-date-text)]
                              [:div {:style {:position "fixed"}}
                               [labelled-input/view
                                {:data-type      :data.type/date
                                 :class          "mb-3"
                                 :value          (:kyc-profile/approval-date @modal-state)
                                 :label          (loc/tr :kyc-profile/approval-date)
                                 :not-clearable? true
                                 :on-change      (fn [new-value]
                                                   (swap! modal-state assoc
                                                          :kyc-profile/approval-date
                                                          new-value))}]]

                              [:div {:style {:height "63px"}}]

                              (when-not skip-risk-category?
                                [:<>
                                 [:div
                                  {:class "mt-5 flex flex-col gap-5"}
                                  [labelled-input/view
                                   {:label (loc/tr :determine-risk-category)
                                    :value       (:kyc-profile/risk-category @modal-state)
                                    :field/attribute :kyc-profile/risk-category
                                    :editor-type :editor.type/search
                                    :data-type :data.type/ref-single
                                    :field/entity-types [:entity.type/kyc-risk-category]
                                    :draggable?  false
                                    :state-atom  modal-state
                                    :attribute   :kyc-profile/risk-category
                                    :on-change (fn [_value value-opt]
                                                 (swap! modal-state assoc :kyc-profile/risk-category value-opt))}]
                                  [labelled-input/view
                                   {:label (loc/tr :justification-for-risk-category)
                                    :data-type   :data.type/text-multiline
                                    :value       (:justification-for-risk-category @modal-state)
                                    :on-change (fn [value]
                                                 (swap! modal-state assoc :justification-for-risk-category value))}]]])])
      :show-button?        true
      :button-text         (loc/tr :ok)
      :custom-validator-fn (fn [modal-state _close-modal!]
                             (let [{:keys [kyc-profile/approval-date
                                           kyc-profile/risk-category
                                           justification-for-risk-category]} @modal-state
                                   risk-category (:value risk-category)
                                   data-missing? (if skip-risk-category?
                                                   (not approval-date)
                                                   (or (not approval-date)
                                                       (not risk-category)
                                                       (cu/blank-value? justification-for-risk-category)))]
                               (when data-missing?
                                 (loc/tr :kyc-approval-fill-all-fields))))
      :on-submit!          (fn [modal-state]
                             (let [{:keys [kyc-profile/approval-date
                                           kyc-profile/risk-category
                                           justification-for-risk-category]} @modal-state
                                   risk-category-id (:value risk-category)

                                   body (cond->
                                         {:kyc-process-id process-id
                                          :new-approval-date approval-date}

                                          (not skip-risk-category?)
                                          (assoc :risk-category-id risk-category-id
                                                 :justification-for-risk-category justification-for-risk-category))]

                               (kyc-process-actions/*->approve! body
                                                                (fn [_resp])
                                                                (fn [resp]
                                                                  (logging/error
                                                                   "Failed to complete KYC "
                                                                   resp)))))
      :on-close!           (fn [])})))

(defn view
  [state-atom process-entity save! field-errors-atom]
  [edit-view/view
   {:state-atom      state-atom
    :save!           save!
    :entity          process-entity
    :mandatory?      true
    :read-only?      false
    :lang            :en
    :field-errors-atom field-errors-atom
    :footer-renderer (fn [_state-atom _answers-atom process-entity]
                       (let [entity-id (:db/id process-entity)
                             attachments (->> process-entity
                                              :common/attachments
                                              (filter (fn [attachment-id]
                                                        ;; template documents??
                                                        (= attachment-id
                                                           (:kyc-process/signed-document
                                                            process-entity))))
                                              (map (partial get @session/entities)))]
                         [:div.d-flex.flex-static.flex-column.kyc-submit-footer

                          [:div
                           {:class-name "container"}
                           [:div
                            {:class-name "grid grid-cols-10 gap-4 px-4"}
                            [:div
                             {:class-name "col-span-10"}
                             [:div.attachment-list.px-0.pb-3
                              (doall
                               (for [attachment attachments]
                                 ^{:key (str "attachment-" entity-id
                                             "-" (or (:db/id attachment)
                                                     attachment))}
                                 [attachments/attachment-view
                                  {:attachment attachment
                                   :target-id  entity-id}]))]]

                            [:div
                             {:class-name "col-span-5"}
                             [kvu/exit-button process-entity :en]]

                            [:div
                             {:class-name "col-span-5"}
                             [:div.d-flex.justify-content-end
                              [:div
                               {:class "flex flex-row gap-2"}
                               [button/warning-solid
                                {:on-click (fn [_]

                                             (kyc-process-actions/*->re-edit-form!
                                              {:kyc-process-id (:db/id process-entity)}
                                              (fn [_resp])
                                              (fn [resp]
                                                (logging/error "Failed to complete KYC " resp))))}
                                (loc/tr :return-for-editing nil)]
                               [button/primary-solid
                                {:on-click (fn [_]
                                             (let [process-id (:db/id process-entity)
                                                   kyc-profile (get-containing-kyc-profile process-id)]
                                               (on-approve-clicked process-entity kyc-profile)))}
                                (loc/tr :approve nil)]
                               [button/danger-solid
                                {:on-click (fn [_]
                                             (kyc-process-actions/*->reject!
                                              {:kyc-process-id (:db/id process-entity)}
                                              (fn [_resp])
                                              (fn [resp]
                                                (logging/error "Failed to complete KYC " resp))))}
                                (loc/tr :reject nil)]]]]]]]))}])

